import { EnumModuloDTOAiMetodoCalcoloFirmeAttese } from '@framework/api-client';
import {
  CheckboxInput,
  FormItem,
  NumberInput,
  SelectInput,
} from '@framework/form';
import { RowElement } from '@framework/ui';
import { AiFormCard } from './form/AiFormCard';

export interface IAiModuleVerifyConfigSectionProps {
  disabled?: boolean;
}
/**
 * Form per la configurazione della verifica delle firme con AI.
 */
export function AiModuleVerifyConfigSection(
  props: IAiModuleVerifyConfigSectionProps,
) {
  const { disabled } = props;

  const options = [
    {
      label: 'Totali nel documento',
      value: EnumModuloDTOAiMetodoCalcoloFirmeAttese.NESSUNO,
    },
    {
      label: 'Per ogni titolare',
      value: EnumModuloDTOAiMetodoCalcoloFirmeAttese.PER_TITOLARE,
    },
  ];

  return (
    <AiFormCard disabled={disabled} title="Verifica firme autografe con AI">
      <RowElement>
        <FormItem
          layout={{ removeHelpMargin: true }}
          name="modulo.aiVerificaFirma"
          label="Verifica firme"
          help="Se attivo, tramite AI saranno verificate le firme sul Modulo."
        >
          <CheckboxInput name="modulo.aiVerificaFirma">
            Verifica firme autografe con AI
          </CheckboxInput>
        </FormItem>
        <FormItem
          layout={{ removeHelpMargin: true }}
          name="modulo.aiNumeroFirmeAttese"
          label="Numero firme attese"
          help="Numero di firme attese sul documento firmato del Modulo."
        >
          <NumberInput name="modulo.aiNumeroFirmeAttese" />
        </FormItem>
        <FormItem
          layout={{ removeHelpMargin: true }}
          name="modulo.aiMetodoCalcoloFirmeAttese"
          label="Modalità firme attese"
          help="Se viene indicato un numero di firme attese, specificare come calcolarle. Per ogni titolare o totali nel documento."
        >
          <SelectInput
            name="modulo.aiMetodoCalcoloFirmeAttese"
            options={options}
          />
        </FormItem>
      </RowElement>
    </AiFormCard>
  );
}
